var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classVal,attrs:{"id":_vm.idVal}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border ic-spinner ic-spinner-green",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }